import { rememberAdminReturnTo } from "../utils/adminReturnTo";
import { Route, Redirect } from "react-router-dom";
import { useFeatureFlag } from "../Contexts/FeatureFlagsContext";
import FullPageLoading from "./FullPageLoading";

/*
 * A signed-in-only route. With `featureFlag`, the route also requires that
 * flag: users without it are sent to `flagOffRedirect`, and nothing renders
 * until the flags have loaded.
 */
function ProtectedRoute({
  sessionStatus,
  user,
  component: Component,
  redirectTo = "/",
  featureFlag,
  flagOffRedirect = "/profile",
  ...routeProps
}) {
  const flag = useFeatureFlag(featureFlag || "");
  return (
    <Route
      {...routeProps}
      render={(renderProps) => {
        if (sessionStatus === "checking") {
          return <FullPageLoading />;
        }
        if (!user?.UID) {
          rememberAdminReturnTo(renderProps.location);
          return <Redirect to={redirectTo} />;
        }
        if (featureFlag) {
          if (!flag.ready) return <FullPageLoading />;
          if (!flag.enabled) return <Redirect to={flagOffRedirect} />;
        }
        return <Component user={user} {...renderProps} />;
      }}
    />
  );
}

export default ProtectedRoute;
